// Centralized date helpers. ALWAYS use these instead of `toISOString().slice(0,10)`
// or `new Date("YYYY-MM-DD")` — those introduce UTC drift and cause weekday/day
// mismatches for users outside UTC (e.g. NL is UTC+1 / UTC+2 in summer).
//
// Contract:
//  - toISO(date)   → "YYYY-MM-DD" in the LOCAL calendar day of the given Date.
//  - todayISO()    → toISO(new Date()).
//  - parseISO(str) → new Date at LOCAL midnight of "YYYY-MM-DD" (no UTC shift).
//  - startOfWeek(d)→ Monday 00:00 LOCAL of the week containing d.
//  - addDays(d,n)  → new Date offset by n days (respecting DST via setDate).

export function toISO(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function todayISO() {
  return toISO(new Date());
}

export function parseISO(str) {
  if (!str) return null;
  // Accept "YYYY-MM-DD" or full ISO — always interpret the date part in local tz.
  const [y, m, d] = String(str).slice(0, 10).split("-").map(Number);
  return new Date(y, (m || 1) - 1, d || 1, 0, 0, 0, 0);
}

export function startOfWeek(d) {
  const x = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
  const day = (x.getDay() + 6) % 7; // 0 = Monday
  x.setDate(x.getDate() - day);
  return x;
}

export function addDays(d, n) {
  const x = new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0, 0);
  x.setDate(x.getDate() + n);
  return x;
}
